export * from './baContentTop.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baContentTop/index.ts